// IKAIKA: "Notify Me" capture for sold-out sizes/variants.
// Sends signups straight to Klaviyo (list + event) via Klaviyo's public
// client-side API. No back-in-stock app installed; this only collects
// interest so we can see signup volume before building the actual alert flow.
(function () {
  var KLAVIYO_COMPANY_ID = 'YqSLyX';
  var KLAVIYO_LIST_ID = 'VdyVUe';
  var KLAVIYO_REVISION = '2026-07-15';

  function getVariantLabel(button) {
    var wrapper = button.closest('form') || document;
    var parts = [];

    var valueSpans = wrapper.querySelectorAll('[data-selected-value-for-option]');
    if (valueSpans.length) {
      valueSpans.forEach(function (span) {
        var label = span.closest('label');
        var name = label ? label.textContent.split(':')[0].trim() : '';
        var value = span.textContent.trim();
        if (value) parts.push(name ? name + ': ' + value : value);
      });
    }

    if (!parts.length) {
      var select = wrapper.querySelector('#variant-selector, [data-variant-select]');
      if (select && select.selectedOptions && select.selectedOptions[0]) {
        parts.push(select.selectedOptions[0].textContent.replace(/\s*-\s*Sold out\s*$/i, '').trim());
      }
    }

    return parts.join(', ');
  }

  function buildNotifyBlock(button) {
    var wrap = document.createElement('div');
    wrap.className = 'ikaika-notify-me hidden';
    wrap.innerHTML =
      '<form class="ikaika-notify-me__form" novalidate>' +
        '<label class="ikaika-notify-me__label fs-body-75" for="ikaika-notify-email-' + Math.random().toString(36).slice(2) + '">' +
          'Want to know when this is back?' +
        '</label>' +
        '<div class="ikaika-notify-me__row">' +
          '<input type="email" class="input ikaika-notify-me__input" placeholder="Your email" required autocomplete="email">' +
          '<button type="submit" class="btn btn--secondary btn--medium ikaika-notify-me__submit">Notify Me</button>' +
        '</div>' +
        '<p class="ikaika-notify-me__status fs-body-75" hidden></p>' +
      '</form>';
    return wrap;
  }

  function showStatus(block, message, isError) {
    var status = block.querySelector('.ikaika-notify-me__status');
    status.textContent = message;
    status.hidden = false;
    status.classList.toggle('ikaika-notify-me__status--error', !!isError);
  }

  function subscribeToKlaviyo(email) {
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        revision: KLAVIYO_REVISION
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Back in Stock request',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: {
                    email: { marketing: { consent: 'SUBSCRIBED' } }
                  }
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: KLAVIYO_LIST_ID } }
          }
        }
      })
    });
  }

  function trackBackInStockEvent(email, productName, variantLabel, productUrl) {
    return fetch('https://a.klaviyo.com/client/events?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        revision: KLAVIYO_REVISION
      },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            properties: {
              ProductName: productName,
              Variant: variantLabel,
              ProductURL: productUrl
            },
            metric: {
              data: {
                type: 'metric',
                attributes: { name: 'Requested Back In Stock' }
              }
            },
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          }
        }
      })
    });
  }

  function wireForm(block, button) {
    var form = block.querySelector('form');

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var input = form.querySelector('.ikaika-notify-me__input');
      var email = input.value.trim();

      if (!email || !input.checkValidity()) {
        showStatus(block, 'Enter a valid email address.', true);
        return;
      }

      var submitBtn = form.querySelector('.ikaika-notify-me__submit');
      submitBtn.disabled = true;

      var productName = document.title.split(/[–—-]/)[0].trim();
      var variantLabel = getVariantLabel(button);
      var productUrl = window.location.href.split('?')[0];

      Promise.all([
        subscribeToKlaviyo(email),
        trackBackInStockEvent(email, productName, variantLabel, productUrl)
      ])
        .then(function () {
          showStatus(block, "You're on the list, we'll email you.", false);
          input.value = '';
        })
        .catch(function () {
          showStatus(block, 'Something went wrong, please try again.', true);
        })
        .finally(function () {
          submitBtn.disabled = false;
        });
    });
  }

  function attach(button) {
    if (button.closest('.sticky-atc-bar')) return;
    if (button.dataset.notifyMeAttached) return;
    button.dataset.notifyMeAttached = 'true';

    var block = buildNotifyBlock(button);
    button.insertAdjacentElement('afterend', block);
    wireForm(block, button);

    var sync = function () {
      var soldOut = button.disabled || button.getAttribute('aria-disabled') === 'true';
      block.classList.toggle('hidden', !soldOut);
    };

    sync();

    new MutationObserver(sync).observe(button, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled']
    });
  }

  function init() {
    document.querySelectorAll('[data-add-to-cart]').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
